import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Antd from 'ant-design-vue'
import axios from 'axios'
import './style.css'
import App from './App.vue'
import router from './router'
import { installTestBridge } from './composables/useTestAction'

installTestBridge()

// 挂载前就让原始 axios 请求带上界面语言，供后端返回本地化文案
axios.defaults.headers.common['ui-lang'] = localStorage.getItem('musex_lang') || 'zh'
const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(Antd)
app.mount('#app')
